// case
export default {
	getBreadcrumbTo(state) {
		return state.breadcrumbTo;
	},
	getCurrentGamePhase(state) {
		return state.currentGamePhase
	},
	getLastEmojiCode(state) {
		return state.lastEmojiCode;
	},

	getGameClientCloseRedirectUrl(state) {
		return state.gameClientCloseRedirectUrl;
	},

	getNavigationGuardEnabled(state) {
		return state.navigationGuardEnabled;
	},

	getGameType(state) {
		return state.gameType;
	},

	getGameClientType(state) {
		return state.gameClientType;
	},

	getLanguage(state) {
		return state.language;
	}
}
